/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Variable para almacenar el registration del Service Worker
let swRegistration = null

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration) {
      console.log('Service worker has been registered.')
      swRegistration = registration

      // Verificar actualizaciones cada hora
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 60) // 60 minutos
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated(registration) {
      console.log('New content is available; please refresh.')
      swRegistration = registration

      // Emitir evento personalizado para notificar a Vue
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

// Función para activar la actualización
export function updateApp() {
  if (!swRegistration || !swRegistration.waiting) {
    return
  }

  // Enviar mensaje al Service Worker en espera para que se active
  swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' })

  // Recargar la página cuando el nuevo SW tome control
  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })
}
